var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("span", [
    _vm.brandLayout !== "generic"
      ? _c(
          "span",
          {
            staticClass: "igt-icon",
            class: [
              { background: _vm.background },
              { img: _vm.mode === "img" },
              "color-".concat(_vm.colorName),
              { count: _vm.count > 0 }
            ]
          },
          [
            _vm.mode === "img"
              ? _c("img", {
                  staticClass: "img",
                  attrs: { src: _vm.name, alt: "Icon" }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.mode === "css"
              ? _c("span", {
                  staticClass: "css",
                  class: _vm.className,
                  style: _vm.styleObject
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.count > 0
              ? _c(
                  "badge",
                  {
                    class: [
                      "badgeIconLive",
                      { small: _vm.moreThanHundredLiveEvents }
                    ]
                  },
                  [_vm._v(_vm._s(_vm.count))]
                )
              : _vm._e()
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.brandLayout === "generic"
      ? _c(
          "span",
          {
            staticClass: "igt-icon",
            class: [
              { background: _vm.background },
              { img: _vm.mode === "img" },
              "color-".concat(_vm.colorName),
              { count: _vm.count > 0 }
            ]
          },
          [
            _vm.mode === "img"
              ? _c("img", {
                  staticClass: "img",
                  attrs: { src: _vm.name, alt: "Icon" }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.mode === "css"
              ? _c("span", {
                  staticClass: "css font-icon",
                  class: "font-" + _vm.className,
                  style: _vm.styleObject
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.count > 0
              ? _c(
                  "badge",
                  {
                    class: [
                      "badgeIconLive",
                      { small: _vm.moreThanHundredLiveEvents }
                    ]
                  },
                  [_vm._v(_vm._s(_vm.count))]
                )
              : _vm._e()
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-484571dd", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-484571dd","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/Icon.vue
// module id = null
// module chunks = 